<script>
	import OffsetThresholdWrapperGBLE from './OffsetThresholdWrapperGBLE.svelte';

	export let device;
</script>

<OffsetThresholdWrapperGBLE {device} setting="offset" type="utc" min={-32768} max={32767} />
